(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-components/assets/javascripts/views/hedges-view.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-components/assets/javascripts/views/hedges-view.js');
"use strict";

const {
  Betslip
} = svs.components.tipsen.betslipComponents;
const HedgesView = () => React.createElement(Betslip.HedgesDisplay, null);
Betslip.HedgesView = HedgesView;

 })(window);